import { createContext } from "react";


const StoredUserContext = createContext(false);

export default StoredUserContext;